/**
 * @generated SignedSource<<d9d7a50caf79c8eed249d80d5da83f56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelEditRoomsRow_room$data = {
  readonly capacity: number | null;
  readonly id: string;
  readonly nameString: string | null;
  readonly " $fragmentType": "HotelEditRoomsRow_room";
};
export type HotelEditRoomsRow_room$key = {
  readonly " $data"?: HotelEditRoomsRow_room$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditRoomsRow_room">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditRoomsRow_room",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameString",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": null
    }
  ],
  "type": "Room",
  "abstractKey": null
};

(node as any).hash = "31c249b14895756fa46aec084bea1267";

export default node;
